import Swiper, {Controller, Navigation} from "swiper";

export default () => {
	const woodEsscenceMenu = new Swiper(".block.wood-essence  .wood-essence__menu", {
		modules: [Controller],
		slidesPerView: "auto",
		spaceBetween: 8,
	});

	const woodEsscenceSlider = new Swiper(".block.wood-essence  .wood-essence__slider", {
		modules: [Navigation, Controller],
		slidesPerView: 1,
		spaceBetween: 240,
		navigation: {
			nextEl: ".swiper-button-next",
			prevEl: ".swiper-button-prev",
		},
	});

	woodEsscenceSlider.controller.control = woodEsscenceMenu
	woodEsscenceMenu.controller.control = woodEsscenceSlider
	woodEsscenceSlider.on('slideChange', () => {
		setTimeout(() => {
			woodEsscenceSlider.slides.forEach((slide, index) => {
				//@ts-ignore
				if (slide === woodEsscenceSlider.slidesEl?.querySelector('.swiper-slide.swiper-slide-active')) {
					woodEsscenceMenu.slides.forEach(item => {
						item.classList.remove('swiper-slide-active');
					})
					woodEsscenceMenu.slides[index].classList.add('swiper-slide-active');
				}
			})
		}, 50)
	})
	woodEsscenceMenu.slides.forEach((slide, index) => {
		slide.onclick = () => {
			woodEsscenceSlider.slideTo(index);
			woodEsscenceMenu.slides.forEach(item => {
				item.classList.remove('swiper-slide-active');
			})
			slide.classList.add('swiper-slide-active');
		}
	})
}
